import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { routes } from '../constants';
import { AsyncActionStatus } from '../actions/common.actionTypes';
import { getMeStatus } from '../reducers/user.selectors';
import useRouter from './useRouter';
import useShouldShowAIAssistant from './useShouldShowAIAssistant';

const useRedirectIfNoAIAssistantAccess = () => {
  const userStatus = useSelector(getMeStatus);
  const shouldShowAssistant = useShouldShowAIAssistant();
  const { router } = useRouter();

  useEffect(() => {
    if (userStatus === AsyncActionStatus.READY && !shouldShowAssistant) {
      router.replace(`/${routes.notFound.root}`);
    }
  }, [router, shouldShowAssistant, userStatus]);

  const isLoading = [
    AsyncActionStatus.LOADING,
    AsyncActionStatus.INITIAL,
  ].includes(userStatus);
  const hasAccess = shouldShowAssistant || isLoading;

  return { isLoading, hasAccess };
};

export default useRedirectIfNoAIAssistantAccess;
